exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.JoinCitSci[data-v-4364c308]{width:160px;margin-left:auto;margin-right:auto;font-weight:bold\n}\n.card-body[data-v-4364c308]{background-color:#f5f4e8 !important\n}", ""]);

// exports
